export default "__VITE_ASSET__DLEVmV6S__"